import Model from "../base/model";

class Location extends Model {
  resourceName() {
    return "location";
  }

  fields() {
    return {
      state: "",
      city: ""
    };
  }

  async search(data) {
    return this.request(
      "tms_external_api/location",
      "POST",
      {},
      data
    );
  }
}
export default new Location();
